import { alpha } from "@mui/material";
import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const getListItemDisabledStyles = (theme) => ({
  color: theme.palette.text.disabled,
  backgroundColor: theme.palette.action.disabledBackground,
  opacity: 1,
  "& .MuiListItemIcon-root, & .MuiListItemText-root": {
    color: theme.palette.text.disabled
  }
});
const getListItemInteractiveStyles = (theme) => ({
  "&.Mui-disabled": {
    ...getListItemDisabledStyles(theme)
  },
  "&.Mui-focusVisible": {
    // Fixes issue where focus styles were also applied to outer menu item when inner element is focused
    backgroundColor: "inherit",
    outline: "inherit"
  },
  "&:hover, &:focus-visible": {
    backgroundColor: theme.palette.action.hover
  },
  "&.Mui-selected": {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.text.primary,
    "&:hover, &.Mui-focusVisible": {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      color: theme.palette.text.primary
    }
  },
  ":focus-visible": {
    outline: `2px solid ${theme.palette.primary.main}`,
    borderRadius: capitalDesignTokens.foundations.units.unitHalf,
    outlineOffset: "-2px"
  }
});
const MuiListItemButton = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemInteractiveStyles(theme)
    })
  }
};
export {
  MuiListItemButton,
  getListItemDisabledStyles,
  getListItemInteractiveStyles
};
//# sourceMappingURL=MuiListItemButton.js.map
